import { Component, OnInit, HostListener } from '@angular/core';
import {CommonUtil} from '../../../../utils/common.util';
import {ConstantUtils} from '../../../../utils/constant.utils';
import {UrlConstants} from '../../../../shared/url.constant';
import { AdminService } from '../../../../shared/admin.services';
import {FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-admin-page-header',
  templateUrl: './admin-pageheader-component.html',
  styleUrls: ['./admin-pageheader.scss']
})



// window.addEventListener('mousemove', () => this.updateLastActivityTimestamp());
// window.addEventListener('keydown', () => this.updateLastActivityTimestamp());
// window.addEventListener('blur', () => this.updateLastActivityTimestamp());
export class AdminPageHeaderComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();
  public schoolName;
  public yearDataList = [];
  public showloader = false;
  public selectedAccYr = '';
  public timeInterval = 5
  // private router: Router
  constructor(private adminService: AdminService, private router: Router) {

    this.loadAllAcademicYear();
  }

  ngOnInit() {

    const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
    const schoolData = bootstrapData['school'];
    this.schoolName = schoolData['school_name'];
    this.timeFunction()
    // this.timeoutId()
    this.initializeActivityTracking()
    $('#search').on('click', function (e) {
      e.preventDefault();
      $('.search-box').fadeIn().addClass('display');
    });
    $('.dismiss').on('click', function () {
      $('.search-box').fadeOut().removeClass('display');
    });

    $('#toggle-btn').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');

      $('#sidebar').toggleClass('shrinked');
      $('.content-inner').toggleClass('active');
      $('.sub-menus').removeClass('show');
      $(document).trigger('sidebarChanged');

      if ($(window).outerWidth() > 1183) {
        if ($('#toggle-btn').hasClass('active')) {
          $('.navbar-header .brand-small').hide();
          $('.navbar-header .brand-big').show();
        } else {
          $('.navbar-header .brand-small').show();
          $('.navbar-header .brand-big').hide();
        }
      }
    });

    const windowWidth = $(window).outerWidth();
    if (windowWidth <= 1183) {
      $('#sidebar').addClass('shrinked');
      $('.navbar-header .brand-small').show();
      $('.navbar-header .brand-big').hide();
      $('.content-inner').addClass('active');

    } else {
      $('#sidebar').removeClass('shrinked');
      $('.navbar-header .brand-small').hide();
      $('.navbar-header .brand-big').show();
      $('.content-inner').removeClass('active');
    }
    // upload sidebar
    $('#dismiss, .overlay').on('click', function () {
      $('#sidebar-upload').removeClass('active');
      $('.overlay').removeClass('active');
  });

  $('#sidebarCollapse').on('click', function () {
      $('#sidebar-upload').addClass('active');
      $('.overlay').addClass('active');
      $('.collapse.in').toggleClass('in');
      $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  });
  }

  @HostListener('window:resize', ['$event'])
  public onResize() {
    const windowWidth = $(window).outerWidth();
    if (windowWidth <= 1199) {
      $('#sidebar').addClass('shrinked');
      $('.navbar-header .brand-small').show();
      $('.navbar-header .brand-big').hide();
      $('.content-inner').addClass('active');

    } else {
      $('#sidebar').removeClass('shrinked');
      $('.navbar-header .brand-small').hide();
      $('.navbar-header .brand-big').show();
      $('.content-inner').removeClass('active');
    }
  }

  public loadAllAcademicYear() {
    this.yearDataList = [];
    this.adminService.loadAcademicYear({ url: UrlConstants.GetAcademicYears, params: '' }).then(res => {
      if (res.count > 0) {
        this.yearDataList = res.data;
      }
      let acObject = this.yearDataList.find((o) => o.is_current == true);
      let currentYr = (acObject) ? acObject.academic_year_id : '';
      let localValue = localStorage.getItem('URL_ACADEMIC_YEAR_ID');
      this.selectedAccYr = (localValue && localValue == 'current') ? currentYr : (localValue);
      console.log('this.selectedAccYr : ', this.selectedAccYr);
    }).catch((err) => {
      console.log(err);
    });
  }

  private updateLastActivityTimestamp() {
    this.timeoutId().clarTimeOut()
    let vineetha = "vine"
    let current = new Date()
    current.setMinutes(current.getMinutes() +65);//65

    const year = current.getFullYear();
    const month = String(current.getMonth() + 1).padStart(2, '0');
    const day = String(current.getDate()).padStart(2, '0');
    const hours = String(current.getHours()).padStart(2, '0');
    const minutes = String(current.getMinutes()).padStart(2, '0');
    // const seconds = String(current.getSeconds()).padStart(2, '0');
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;

    let formatStr = `${current}`
    window['activeApplicationTimeStamps'] = 65*60*1000

    localStorage.setItem('lastUpdate', formattedDateTime)
    this.timeoutId()
  }
  private checkInactivity() {

  }
  private initializeActivityTracking() {
    window.addEventListener('mousemove', () => this.updateLastActivityTimestamp());
    window.addEventListener('keydown', () => this.updateLastActivityTimestamp());
    window.addEventListener('blur', () => this.updateLastActivityTimestamp());
  }
  public timeoutId() {
    const executTimeout = setTimeout(() => {
      let localDate=localStorage.getItem('lastUpdate')&&new Date(localStorage.getItem('lastUpdate'))
      let nowDate=new Date()
      const isSameOrLessthanDate =
      localDate.getFullYear() <= nowDate.getFullYear() &&
      localDate.getMonth() <= nowDate.getMonth() &&
      localDate.getDate() <= nowDate.getDate() &&
      localDate.getHours() <= nowDate.getHours() &&
      localDate.getMinutes() <= nowDate.getMinutes();
      // const timeDifference = localDate - nowDate;
      const timeDifference =localDate.getTime()-Date.now()  //- Date.now();
      if(isSameOrLessthanDate){
        this.router.navigate(['/admin/login'])
      }else{
        window['activeApplicationTimeStamps'] = timeDifference
        this.timeoutId()
      }
      const timeDifferenceInMinutes = Math.abs(nowDate.getMinutes() - localDate.getMinutes());
      const timeDifferenceInHours = Math.abs(nowDate.getMinutes() - localDate.getMinutes());

      // this.router.navigate(['/admin/login'])
    }, window['activeApplicationTimeStamps']);
    const clarTimeOut = () => {
      clearTimeout(executTimeout)
    }
    return {
      executTimeout, clarTimeOut
    }
  }

  public onChangeAcademicYear(value) {
    this.showloader = true;
    let setValue = value;
    localStorage.setItem('URL_ACADEMIC_YEAR_ID', '');

    let acObject = this.yearDataList.find((o) => o.academic_year_id == setValue);
    if (acObject && acObject.is_current) {
      setValue = 'current';
    }
    this.selectedAccYr = setValue;
    localStorage.setItem('URL_ACADEMIC_YEAR_ID', setValue);
    window.location.reload();
  }
  public timeFunction() {
    //   console.log("from time.....")


    setInterval(() => {
      let configData = {
        token: localStorage.getItem('userToken'),
        refresh_token: localStorage.getItem('refreshToken')
      }
      if (configData.refresh_token) {
        this.adminService.refreshTokenRoute({ url: UrlConstants.adminRefreshToken, params: configData }).then(res => {
          console.log(res)
          localStorage.setItem('userToken', res.token)

        }).catch((err) => {
          console.log(err, "refreshhhhhhhhhhhhhhhhhhhh");
        });
      }

    }, 15 * 60 * 1000)
  }
}
